import React, {useState} from "react";
import "plyr-react/plyr.css"
import {Flex} from "@chakra-ui/react";
import {useWorkspace} from "../../context/WorkspaceContext";
import {TranscriptPage} from "./transcript-page";

export default function TranscriptEditor() {
    const [loading, setLoading] = useState<boolean>(true);
    const workspace: any = useWorkspace()

    return (
        <Flex w={'full'} direction={'column'} gap={'16px'} alignItems={'flex-start'}>
            <TranscriptPage />
        </Flex>
    );
};
